import { useRef, useState } from "react";
import { func, string } from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import { ColorPicker, Button } from "@components";
import { Add } from "@material-ui/icons";

export const NewColorButton = ({
  selectedColor,
  onChange,
  onComplete
}) => {
  
  const theme = useTheme();
  const classes = useStyle();
  
  const [pickerVisible, showPicker] = useState(false);
  
  const ref = useRef(null);
  
  const handleSelect = (hex) => {
    onComplete(hex);
    showPicker(false);
  }
  
  return <>
    <Button
      ref={ref}
      color="primary"
      className={classes.button}
      onClick={() => showPicker(true)}
    >
      <Add />
    </Button>
    {
      pickerVisible &&
      <ColorPicker
        anchor={ref.current}
        show
        revertOnCancel
        originalColor={selectedColor}
        initialColor={theme.palette.primary.main}
        onClose={() => showPicker(false)}
        onChange={onChange}
        onAccept={handleSelect}
      />
    }
  </>
}

NewColorButton.propTypes = {
  onComplete: func.isRequired,
  onChange: func.isRequired,
  selectedColor: string,
}

const useStyle = makeStyles((theme) => ({
  button: {
    height: 24,
    width: 24,
    minWidth: 24,
    margin: 4,
    padding: 0,
    borderRadius: 5,
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));